module.exports = __webpack_public_path__ + "static/img/ad9.48ea049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newSpark/ad9.png
// module id = 5hA0
// module chunks = 13